















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class UrlCopy extends Vue {
    @Prop({required:true}) label!:string;
    @Prop({required:true}) url!:string;
    copy(){
        /* Select the text field */
        let copyText : any = document.getElementById(this.url);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
        /* Copy the text inside the text field */
        document.execCommand("copy");
    }
    open(){
        window.open(this.url,"blank");
    }
}
